import React, { useEffect, useState } from "react";

import { Button, Form, Modal, Dropdown } from "react-bootstrap";
import ModalLoader from "../ModalLoader";
import { toast } from "react-toastify";
import { URLS } from "../urls";
import { checkStartDate, fetchActionsUtil, useCookie } from "../../utils";
import Cookies from "universal-cookie";
import moment from "moment";
import Papa from "papaparse";
import { CloudIcon, ExcelIcon, ImportIcon, MobileArrowDown } from "../icons";
import { Close } from "@mui/icons-material";
import RsDateRangePicker from "../RsDateRangePicker";

export default function AddRosterPlanningModal({
  setShowUploadModal,
  showAttendance,
  setshowSaveButton,
}) {
  const cookies = new Cookies();
  const userId = cookies.get("userId");
  const nowDate = new Date();

  const branch_id = useCookie("branch_id");
  const [loading, setLoading] = useState(false);
  const [CheckTotal, setCheckTotal] = useState(0);

  const [excellDetails, setExcellDetails] = useState([]);
  const [selectedDates, setSelectedDates] = useState({
    startDate: nowDate,
    endDate: nowDate,
  });

  const uploadTimeSheet = (e) => {
    e.preventDefault(e);
    showAttendance(excellDetails);
    setshowSaveButton(true);
    setShowUploadModal(false);
  };

  // Function to handle file upload
  function handleFile({ eventData: e }) {
    setLoading(true);

    const file = e?.target?.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = async function ({ target }) {
        try {
          const { employees } = await fetchActionsUtil(
            `${URLS.backendEmployees}/get/${branch_id}`
          );

          const parsedData = [];
          Papa.parse(target?.result, {
            header: true,
            step: function (row) {
              parsedData.push(row.data);
            },
            complete: function () {
              const workIdSet = new Set(employees?.map((el) => el?.Staff_ID));
              const start = moment(selectedDates.startDate, "MM/DD/YYYY");
              const end = moment(selectedDates.endDate, "MM/DD/YYYY");

              const dateKeyMap = new Map();

              for (const el of parsedData) {
                if (!workIdSet.has(el.WorkId)) continue;

                const date = moment(el.Date, "MM/DD/YYYY");
                if (!date.isBetween(start, end, undefined, "[]")) continue;

                const key = `${el.WorkId}-${el.Date}`;
                if (!dateKeyMap.has(key)) dateKeyMap.set(key, []);
                dateKeyMap.get(key).push(el);
              }

              const allEmployees = [];

              for (const [key, entries] of dateKeyMap.entries()) {
                const sorted = entries.sort(
                  (a, b) =>
                    moment(a.TimeIn, "HH:mm").valueOf() -
                    moment(b.TimeIn, "HH:mm").valueOf()
                );

                const endpoints = [sorted[0]];
                if (sorted.length > 1)
                  endpoints.push(sorted[sorted.length - 1]);

                for (const item of endpoints) {
                  const user = employees?.find(
                    (em) => em.Staff_ID === item.WorkId
                  );
                  const nameInfo = user?.personalInfo?.name || {};
                  const name = `${nameInfo.first || ""} ${
                    nameInfo.middle || ""
                  } ${nameInfo.last || ""}`.trim();

                  allEmployees.push({
                    ...item,
                    Name: name,
                    ID: item.WorkId,
                  });
                }
              }
              setCheckTotal(allEmployees.length);
              setExcellDetails(allEmployees);
            },
          });
        } catch (err) {
          console.log(err);
        } finally {
          setLoading(false);
        }
      };
      reader.readAsText(file);
      e.target.value = "";
    }
  }

  const cancelRequest = (e) => {
    e.preventDefault(e);
    setSelectedDates({
      startDate: nowDate,
      endDate: nowDate,
    });
    setExcellDetails([]);
    setCheckTotal(0);
  };

  const filterByDateRange = (event, picker) => {
    setSelectedDates({
      startDate: picker.startDate.format("MM/DD/YYYY"),
      endDate: picker.endDate.format("MM/DD/YYYY"),
    });
    picker.element.value = `${picker.startDate.format(
      "MM/DD/YYYY"
    )} - ${picker.endDate.format("MM/DD/YYYY")}`;
  };

  const clearDateRange = (event, picker) => {
    setSelectedDates({
      startDate: nowDate,
      endDate: nowDate,
    });

    picker.element.value = "";
  };

  return (
    <>
      <Modal
        className="custom-modal"
        show={true}
        centered
        onHide={() => {
          setShowUploadModal(false);
        }}
      >
        <Form className="">
          {/* <Modal.Header>
            <Modal.Title>Import Attendance</Modal.Title>
          </Modal.Header> */}
          <div className="d-flex align-items-center px-5 pt-5 justify-content-between gap-4">
            <h5 className="page-title page-title-alt m-0 p-0">Import Roster</h5>
            <div
              className="btn-close-alt"
              onClick={() => {
                setShowUploadModal(false);
              }}
            >
              <Close />
            </div>
          </div>
          <Modal.Body>
            <input name="employeeId" type="hidden" value={userId} />
            <input name="branch_id" type="hidden" value={branch_id} />

            <div className="my-4">
              <label className="ml-2 text-16 font-600  light-text mb-2">
                Select your range
              </label>
              <RsDateRangePicker
                placement="topEnd"
                className="form-control-w-0 w-100"
                onClean={(event, picker) => clearDateRange(event, picker)}
                onOk={(event, picker) => filterByDateRange(event, picker)}
              />
            </div>

            <div className="w-full d-flex mr-2 ml-2 mt-4 align-items-center justify-content-between">
              <label className="p-cursor" title="Import">
                <input
                  type="file"
                  className="d-none"
                  onChange={(e) => {
                    handleFile({
                      eventData: e,
                    });
                  }}
                  accept=".csv"
                />
                <ExcelIcon color="#008000" />{" "}
                <span className="mx-2">Upload from Excel</span>
              </label>

              <div className="dark-text fw-bold ">
                <p>{`${CheckTotal} Rows`}</p>
              </div>
            </div>
            <hr />
            <div className="d-flex align-items-center gap-4 ml-2 mt-6">
              {excellDetails.length > 0 && (
                <Button onClick={(e) => uploadTimeSheet(e)}>View</Button>
              )}

              <button
                className="btn btn-secondary btn-secondary-alt"
                onClick={(e) => cancelRequest(e)}
              >
                Cancel
              </button>
            </div>
          </Modal.Body>
          <Modal.Footer className="text-left"></Modal.Footer>
        </Form>
      </Modal>
      <ModalLoader show={loading} />
    </>
  );
}
